import React from 'react';
import Img from '../../../../../components/Img';
import Anchor from '../../../../../components/link/Anchor';
import Tag from '../../../../../components/tag/Tag';
import TableFilterInput from '../../../../../components/table/TableFilterInput';
import DateRangePicker from '../../../../../components/datePicker/DateRangePicker';
import OpenPreviewTagDetail from '../../../../../containers/app/common/OpenPreviewTagDetail';
import { TAG_HISTORY_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { TAG_LOG_TYPE } from '../../../../../constants/service/app/tagConstants';
import { setDash, setDetailPageUrl } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';
import { ACCOUNT_USER_DETAIL_TAG_LOG_LIST_SORT_OPTION_MODEL } from '../../../../../store/modules/account/user/models';
import TableColumnImg from '../../../../../components/table/TableColumnImg';

/**
 *  팔로우 태그 리스트 컬럼
 */
const columns = (data) => {
  const { filterOption, onFilter, getRelatedTagList, getAccountUserDetailTagLogList } = data;

  return [
    {
      accessor: 'url',
      Header: '이미지',
      width: 100,
      Cell: (row) => <TableColumnImg url={row.value} />,
    },
    {
      accessor: 'tagId',
      Header: '태그 ID',
      filterable: true,
      width: 120,
      Cell: (row) => (
        <Anchor
          text={row.value}
          isUnderLine
          color="primary"
          href={setDetailPageUrl(TAG_HISTORY_URL_PATH, row.value)}
          target="_blank"
        />
      ),
      Filter: () => <TableFilterInput option={filterOption.tagId} onFilter={(tagId) => onFilter({ tagId })} />,
    },
    {
      accessor: 'tagName',
      Header: '태그명',
      filterable: true,
      Cell: (row) => <OpenPreviewTagDetail text={row.value} tagId={row.original.tagId} />,
      Filter: () => <TableFilterInput option={filterOption.tagName} onFilter={(tagName) => onFilter({ tagName })} />,
    },
    {
      accessor: 'tagGroupList',
      Header: '태그 그룹',
      filterable: true,
      Cell: (row) =>
        row.value && row.value.length
          ? row.value.map((tagGroupName, index) => <Tag key={index} text={tagGroupName} isAddHash={false} />)
          : setDash(row.value),
      Filter: () => (
        <TableFilterInput option={filterOption.tagGroupList} onFilter={(tagGroupList) => onFilter({ tagGroupList })} />
      ),
    },
    {
      accessor: 'isRelatedTagExists',
      Header: '연관된 태그',
      width: 100,
      Cell: (row) => (
        <Anchor
          text="태그 보기"
          isUnderLine
          color="primary"
          onClick={() =>
            getRelatedTagList({
              tagId: row.original.tagId,
            })
          }
        />
      ),
    },
    {
      accessor: 'tagClickCount',
      Header: '태그 클릭 수',
      sortable: true,
      width: 150,
      Cell: (row) => (
        <Anchor
          text={row.value}
          isUnderLine
          color="primary"
          onClick={() =>
            getAccountUserDetailTagLogList({
              tagId: row.original.tagId,
              filterOption: {
                actionLogType: TAG_LOG_TYPE.CLICK,
              },
              sortOption: ACCOUNT_USER_DETAIL_TAG_LOG_LIST_SORT_OPTION_MODEL,
            })
          }
        />
      ),
    },
    {
      accessor: 'lastFollowTagDate',
      Header: '최신 팔로우 추가 일시',
      filterable: true,
      sortable: true,
      width: 180,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_KOREAN_FORMAT),
      Filter: () => (
        <DateRangePicker
          value={filterOption.lastFollowTagDate}
          outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
          onSelect={(data) => onFilter({ lastFollowTagDate: data })}
        />
      ),
    },
  ];
};

export default columns;
